<template>
  <el-dropdown
    trigger="click"
    @command="onDropdownAction"
  >
    <span class="el-dropdown-link">
      <div :class="`more-action__button ic-${iconType}`" />
    </span>

    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-for="(dropdownItem, dropdownIndex) in dropdownItems"
        :key="dropdownIndex"
        :command="dropdownItem.action"
      >
        {{ dropdownItem.label }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  name: 'MoreActionDropdown',
  props: {
    dropdownItems: {
      type: Array,
    },
    payloadData: {
      type: Object,
    },
    iconType:{
      default: 'more',
      type: String,
    },
  },
  computed: {},
  methods: {
    onDropdownAction(action) {
      this.$emit('command', {
        action,
        data: this.payloadData,
      });
    },
  },
};
</script>

<style lang="scss">
.el-dropdown-link{
	&:focus{
		outline: 0;
	}
}
</style>
